import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { AuthHttp } from "angular2-jwt/angular2-jwt";
import { SessionStorageService } from "ngx-webstorage/dist/services";
import { ConstantService } from "../../../components/common/utils/constant.service";
import { ClienteLogin, Cliente, ClienteXCiudad } from "../../login/cliente_login";
import { Headers, Http, Response, RequestOptions, ResponseContentType } from '@angular/http';
import { ListaDiccionaryEntity } from "../../../components/common/utils/entities/lista_dictionary_entity";
import { ContratistaEntity, ContratosEntity, ContratosExcel, BuscaContratista } from "../entities/contratistas_entity";
import { Archivo, BuscaArchivos } from '../../../components/common/utils/entities/util_entity';


declare var jQuery: any;

@Injectable()

export class ContratistasService {
    private url = "contratistas";
    usuario: ClienteLogin;
    userEmpresa: ClienteXCiudad;



    constructor(public authHttp: AuthHttp, private sessionStorageService: SessionStorageService) {
        let constantService = new ConstantService();
        this.url = constantService.API_ENDPOINT + this.url;
    }

    consultarListContratistas(userEmpresa: ClienteXCiudad): Observable<ListaDiccionaryEntity[]> {
        let body = JSON.stringify(userEmpresa);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/consultarContratistas", body, options).map(this.extractData)
            .catch(this.handleError);
    }

    consultarContratos(contratista: ContratistaEntity): Observable<ContratosEntity[]> {
        let body = JSON.stringify(contratista);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/consultarContratos", body, options).map(this.extractData)
            .catch(this.handleError);

    }
    generarListadoContratos(contratos: ContratosExcel): Observable<any> {
        let body = JSON.stringify(contratos);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/exportarContratos", body, options).map(this.extractData)

    }
    BuscarContratista(datos: BuscaContratista): Observable<any> {
        let body = JSON.stringify(datos);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/buscarContratista", body, options).map(this.extractData)

    }


    GuardarContratista(nuevo: ContratistaEntity): Observable<any> {
        let body = JSON.stringify(nuevo);
        let headers = new Headers({ 'Content-Type': 'application/json' , 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/guardarContratistas", body, options).map(this.extractData)

    }
    ConsultarAdjuntosContrato(datosBusqueda: BuscaArchivos): Observable<Archivo[]> {
        let body = JSON.stringify(datosBusqueda);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/ListaArchivosContratistas", body, options).map(this.extractData)
       
    }
    getArchivo(consulta: Archivo): Observable<any> {
        let body = JSON.stringify(consulta);
        let headers = new Headers();
        if (consulta.Extension.toUpperCase() == "XLSX") {
            headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token"), 'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        } else {
            headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token"), 'Accept': 'application/pdf' });
        }
        let options = new RequestOptions({ headers: headers });
        options.responseType = ResponseContentType.Blob;
        return this.authHttp.post(this.url + "/getArchivoRepositorio", body, options).map(response => response)
            .catch(this.handleError);
    }
    
    private extractData(res: Response) {
        let body = res.json();
        return body || {};
    }
    private handleError(error: any) {
        return Observable.throw(error);
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/contratistas/contratistas.service.ts